var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.colors.length > 0)?_c('div',{staticClass:"blocks-section"},_vm._l((_vm.colors),function(color,i){return _c('v-chip',{key:i,staticClass:"mr-1 mt-1",attrs:{"small":"","color":color,"dark":""}},[_vm._v(" "+_vm._s(`${_vm.$tc('common.blocks', 1)} ${i + 1}`)+" ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }